import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
interface BenefitCardProps {
  title: string;
  bannerUrl: string;
  pcBannerUrl?: string;
  href: string;
  priority?: boolean;
}
export const BenefitCard = t0 => {
  const $ = _c(12);
  const {
    title,
    bannerUrl,
    pcBannerUrl,
    href
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("relative block aspect-[1200/180] overflow-hidden rounded-medium", "mobile-tablet:aspect-[335/124]");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== bannerUrl || $[2] !== title) {
    t2 = <Image src={bannerUrl} alt={title} fill={true} sizes="(max-width: 1279px) 100vw" className="hidden object-cover mobile-tablet:block" />;
    $[1] = bannerUrl;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = pcBannerUrl ?? bannerUrl;
  let t4;
  if ($[4] !== t3 || $[5] !== title) {
    t4 = <Image src={t3} alt={title} fill={true} sizes="(min-width: 1280px) 100vw" className="object-cover mobile-tablet:hidden" />;
    $[4] = t3;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== href || $[8] !== t2 || $[9] !== t4 || $[10] !== title) {
    t5 = <CustomLink href={href} className={t1} aria-label={title}>{t2}{t4}</CustomLink>;
    $[7] = href;
    $[8] = t2;
    $[9] = t4;
    $[10] = title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};